import { render, staticRenderFns } from "./MonitoringHutangDetail.vue?vue&type=template&id=512f9786"
import script from "./MonitoringHutangDetail.vue?vue&type=script&lang=js"
export * from "./MonitoringHutangDetail.vue?vue&type=script&lang=js"
import style0 from "./MonitoringHutangDetail.vue?vue&type=style&index=0&id=512f9786&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports